import { Injectable, WritableSignal, inject } from '@angular/core';
import { Router } from '@angular/router';
import { messages as msg } from '@env/environment';
import { TableService } from '@shared/components/table/table.service';
import { ToastrService } from 'ngx-toastr';

interface IPaginatedResponse {
  totalElements: number;
  number: number;
  content: Record<string, number | string | boolean>[];
}

@Injectable({
  providedIn: 'root',
})
export class SuccessGetAllService<T extends IPaginatedResponse> {
  private _msg = msg;
  private readonly _toastr = inject(ToastrService);
  private readonly _tableSvc = inject(TableService);
  private readonly _router = inject(Router);

  public successGetAll(resp: T, redirectTo: () => void, actualizarDatos: (resp: T) => void, searchSignal: WritableSignal<string>, pageSignal: WritableSignal<number>): void {
    if (resp.totalElements < 1) {
      this._toastr.info(this._msg.no_hay_datos, this._msg.title_info);

      searchSignal.set('');
      pageSignal.set(0);
      this._tableSvc.setSpinner(true);
      setTimeout(() => {
        this._router.navigate([redirectTo()]);
      }, 1000);
    } else if (resp.content.length < 1 && resp.number > 0) {
      this._toastr.info(this._msg.no_hay_datos, this._msg.title_info);
      searchSignal.set('');
      pageSignal.set(resp.number - 1);
    } else {
      if (resp.content && resp.content.every((item) => item === null)) {
        this._toastr.info(this._msg.no_hay_datos, this._msg.title_info);
        searchSignal.set('');
        pageSignal.set(0);
        this._tableSvc.setBusquedaAnidada('');
        this._tableSvc.setSpinner(true);
      } else {
        this._tableSvc.setSpinner(true);
        actualizarDatos(resp);
      }
    }
  }
}
